import { defineMessages } from 'react-intl-next';

export default defineMessages({
	rovoButton: {
		id: 'ai-smart-button.ai-button.button-label',
		defaultMessage: 'Open Rovo Chat',
		description: 'The visually-hidden accessible label for the button that opens Rovo Chat. Must describe the action, not the element type.',
	},
});
